<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>แพทย์ 
        <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(lang)=='en'"></span>
        <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(lang)" v-if="covertoLowerCase(lang)!='en'"></span>
        </b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link :to="{ name: 'DoctorAdd'}"><button class="btn btn-lg btn-primary" type="button"><i class="fas fa-plus"></i>
              เพิ่ม</button></router-link>
        </li>
      </ul>
    </nav>
    <div v-for="valueDoctor in data.doctors" class="card col-md-12" :key="valueDoctor.id">
      <div class="card-body">
        <div class="row bd-example2">
          <div class="col-sm-12 col-lg-4">
            <img v-bind:src="valueDoctor.image" @error="imageLoadError" class="d-block w-full">
          </div>          
          <div class="col-sm-12 col-lg-8">
            <div id="spy-example2" data-spy="scroll" data-target="#list-example" data-offset="0">
              <h4 class="text-center">
                <b v-html="valueDoctor.name"></b>
              </h4>
              <div class="col-sm-12" v-if="valueDoctor.specialty_name!=''">
                <p><b><span v-html="valueDoctor.specialty_name"></span></b></p>
              </div>
              <div class="col-sm-12" v-if="valueDoctor.clinic_name!=''">
                <p><b>คลินิก:</b>&nbsp;<span v-html="valueDoctor.clinic_name"></span></p>
              </div>
              <label v-if="valueDoctor.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ valueDoctor.created_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="col-sm-12 col-lg-12 row">
              <div class="col-sm-12 col-lg-4">
                  <div class="col-sm-12 col-lg-12 row">
                    <div class="ml-4" v-for="valueLang of valueDoctor.languages" :key="valueLang">
                      <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-us'" v-if="covertoLowerCase(valueLang)=='en'"></span>
                      <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-'+covertoLowerCase(valueLang)" v-if="covertoLowerCase(valueLang)!='en'"></span>
                    </div>
                  </div>
              </div>
              <div class="col-sm-12 col-lg-8">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6">
                      <b-btn @click="$router.push({ name: 'DoctorEdit',params: { id: valueDoctor.id }})" class="mt-3"
                        variant="outline-primary" block><i class="fas fa-edit"></i> แก้ไข</b-btn>
                    </div>
                    <div class="col-lg-6 col-sm-6">
                      <b-btn @click="alertDeleteDoctor(valueDoctor.id,valueDoctor.name)" class="mt-3" variant="outline-primary"
                        block><i class="fas fa-trash-alt"></i> ลบ</b-btn>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="doctor.alert.title" ref="alert" hide-footer v-model="doctor.alert.active" @ok="doctor.alert.active = false">
      <div v-if="doctor.alert.load==false">
        <div class="row">
          <div class="col-md-12 text-center">
            <span v-html="doctor.alert.detail"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="doctor.alert.open.active">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitDelete"><span v-html="doctor.alert.open.name"></span></b-btn>
          </div>
          <div class="col-lg-3" v-if="doctor.alert.open.active==false"></div>
          <div class="col-lg-6" v-if="doctor.alert.close.active">
            <b-btn class="mt-3" variant="outline-secondary" block @click="closeAlert"><span v-html="doctor.alert.close.name"></span></b-btn>
          </div>
        </div>
      </div>
      <div v-if="doctor.alert.load">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <div v-if="data.per_page&&data.per_page!=null&&data.per_page>1" class="w-full">
      <b-pagination align="center" :total-rows="data.per_page*data.per_page" v-on:input="getDoctors" v-model="data.page"
        :per-page="data.per_page"></b-pagination>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        doctor: {
          id: null,
          name: '',
          alert: {
            title: '',
            open: {
              active: false,
              name: ''
            },
            close: {
              active: false,
              name: ''
            },
            image: null,
            action: '',
            detail: '',
            active: false,
            load: false
          }
        },
        lang: this.$route.query.lang,
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          page: this.$route.query.page,
          per_page: null,
          doctors: {}
        }
      }
    },
    mounted() {
      if(!this.lang){
        this.lang = 'th'
      }
      this.checkLang()
      this.startLoad(1)
      this.getDoctors()
    },
    methods: {
      covertoLowerCase(title){
        if(title&&title!=''){
          return title.toLowerCase()
        }else{
          return title
        }
      },
      checkLang(){
        if(!this.lang){
          this.lang='th'
        }
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      closeAlert() {
        this.$refs.alert.hide()
      },
      alertDeleteDoctor(doctorID, doctorName) {
        this.doctor.id = doctorID
        this.doctor.name = doctorName
        this.doctor.alert.title = 'การลบแพทย์'
        this.doctor.alert.detail = 'คุณต้องการลบแพทย์ "<b>' + doctorName + '</b>" ใช่หรือไม่?'
        this.doctor.alert.open.active = true
        this.doctor.alert.close.active = true
        this.doctor.alert.open.name = 'ยืนยันการลบ'
        this.doctor.alert.close.name = 'ยกเลิกการลบ'
        this.doctor.alert.active = true
      },
      submitDelete() {
        this.doctor.alert.load = true
        this.deleteDoctorByID()
      },
      getDoctors() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/doctors', {
          params: {
            page: this.data.page,
            per_page: this.data.per_page,
            lang: this.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          this.lang = response.data.json.lang
          this.checkLoad()
          moment.locale(this.lang)
            this.data.page = parseInt(response.data.json.page)
            this.data.per_page = parseInt(response.data.json.per_page)
            this.$router.replace({ name: 'DoctorList',query: { page: this.data.page,lang: this.lang }})
          this.data.doctors = response.data.json.data
        }).catch(function (error) {
          this.failLoad()
          this.doctor.alert.title = 'การดึงข้อมูลแพทย์'
          this.doctor.alert.detail = 'ไม่สามารถทำการดึงแพทย์ได้!'
          this.doctor.alert.open.active = false
          this.doctor.alert.close.name = 'ปิด'
          this.doctor.alert.active = true
        })
      },
      deleteDoctorByID() {
        if (this.doctor.id && this.doctor.id != '') {
          this.startLoad(2)
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/doctor/' + this.doctor.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.checkLoad()
            this.doctor.alert.load = false
            this.getDoctors()
            this.doctor.alert.detail = 'ทำการลบแพทย์หมายเลข: ' + response.body.json.doctor.id + ' เรียบร้อย'
            this.doctor.alert.open.active = false
            this.doctor.alert.close.name = 'ปิด'
            this.doctor.alert.active = true
          }).catch(function (error) {
            this.failLoad()
            this.doctor.alert.detail = 'ไม่สามารถทำการลบแพทย์ได้!'
            this.doctor.alert.open.active = false
            this.doctor.alert.close.name = 'ปิด'
            this.doctor.alert.active = true
          })
        }
      },
      imageLoadError(event){
        event.target.src = this.no_image.src
      }
    }
  }

</script>
